const defaultEnvironment = () => ({
  document,
  window,
  requestAnimationFrame: window.requestAnimationFrame.bind(window),
});

const scrollTopOf = (container, browserWindow) =>
  container === browserWindow ? browserWindow.scrollY : container.scrollTop;

const setScrollTop = (container, value, browserWindow) => {
  if (container === browserWindow) {
    browserWindow.scrollTo({ top: value, behavior: 'auto' });
  } else {
    container.scrollTop = value;
  }
};

export const captureViewportAnchor = (
  anchorIds,
  environment = defaultEnvironment()
) => {
  const ids = (Array.isArray(anchorIds) ? anchorIds : [anchorIds]).filter(
    Boolean
  );
  const element = ids
    .map((id) => environment.document.getElementById(id))
    .find(Boolean);
  if (!element) return null;

  const candidate = element.closest('[data-book-scroll-container]');
  const container =
    candidate && candidate.scrollHeight > candidate.clientHeight
      ? candidate
      : environment.window;

  return {
    anchorIds: ids,
    viewportTop: element.getBoundingClientRect().top,
    container,
    scrollTop: scrollTopOf(container, environment.window),
  };
};

export const restoreViewportAnchor = (
  snapshot,
  environment = defaultEnvironment()
) => {
  if (!snapshot) return false;
  const element = snapshot.anchorIds
    .map((id) => environment.document.getElementById(id))
    .find(Boolean);

  if (!element) {
    setScrollTop(
      snapshot.container,
      snapshot.scrollTop,
      environment.window
    );
    return false;
  }

  const delta =
    element.getBoundingClientRect().top - snapshot.viewportTop;
  setScrollTop(
    snapshot.container,
    scrollTopOf(snapshot.container, environment.window) + delta,
    environment.window
  );
  return true;
};

export const restoreViewportAnchorAfterRender = (
  snapshot,
  environment = defaultEnvironment()
) =>
  new Promise((resolve) => {
    environment.requestAnimationFrame(() => {
      environment.requestAnimationFrame(() => {
        resolve(restoreViewportAnchor(snapshot, environment));
      });
    });
  });
